"use strict";

exports.__esModule = true;
exports.ElementSizeControlGroup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _reactIntl = require("react-intl");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Controls for changing the size of the selected element
 */
var ElementSizeControlGroup = exports.ElementSizeControlGroup = /*#__PURE__*/function (_Component) {
  function ElementSizeControlGroup() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ElementSizeControlGroup, _Component);
  var _proto = ElementSizeControlGroup.prototype;
  _proto.render = function render() {
    var elementEditor = this.props.elementEditor;
    var selectedPath = elementEditor.selectedPath;
    var element = elementEditor.getElementAt(selectedPath);
    if (element === undefined) {
      return null;
    }
    var width = selectedPath;
    var height = selectedPath;
    var isResizable = elementEditor.canResizeElementAt(selectedPath);
    if (!isResizable) {
      var _elementEditor$getRel = elementEditor.getRelativeSizeControlPaths();
      width = _elementEditor$getRel.width;
      height = _elementEditor$getRel.height;
      if (width === undefined && height === undefined) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, width && /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        key: "width",
        label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "ElementSizeControlGroup.relativeWidth.label",
          defaultMessage: "Relative Width"
        }),
        helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "ElementSizeControlGroup.relativeWidth.helperText",
          defaultMessage: "The width of this element relative to others in the same row."
        })
      }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
        labelRenderer: false,
        min: 1,
        max: 20,
        value: elementEditor.getProp(width, "flex", 1),
        onChange: function onChange(value) {
          return elementEditor.setProp(width, "flex", value);
        }
      })), height && /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        key: "height",
        label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "ElementSizeControlGroup.relativeHeight.label",
          defaultMessage: "Relative Height"
        }),
        helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
          id: "ElementSizeControlGroup.relativeHeight.helperText",
          defaultMessage: "The height of this element relative to others in the same column."
        })
      }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
        labelRenderer: false,
        min: 1,
        max: 20,
        value: elementEditor.getProp(height, "flex", 1),
        onChange: function onChange(value) {
          return elementEditor.setProp(height, "flex", value);
        }
      })));
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ElementSizeControlGroup.width.label",
        defaultMessage: "Width"
      }),
      helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ElementSizeControlGroup.width.helperText",
        defaultMessage: "The width of this element."
      }),
      disabled: !width
    }, /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "ElementSizeControlGroup.slider.width"
    }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
      labelRenderer: false,
      min: 1,
      max: 3840,
      value: elementEditor.getProp(width, "width") || 1,
      onChange: function onChange(value) {
        return elementEditor.setProp(width, "width", value);
      },
      disabled: !width
    }))), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ElementSizeControlGroup.height.label",
        defaultMessage: "Height"
      }),
      helperText: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "ElementSizeControlGroup.height.helperText",
        defaultMessage: "The height of this element."
      }),
      disabled: !height
    }, /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "ElementSizeControlGroup.slider.height"
    }, /*#__PURE__*/_react["default"].createElement(_core.Slider, {
      labelRenderer: false,
      min: 1,
      max: 2160,
      value: elementEditor.getProp(height, "height") || 1,
      onChange: function onChange(value) {
        return elementEditor.setProp(height, "height", value);
      },
      disabled: !height
    }))));
  };
  return ElementSizeControlGroup;
}(_react.Component);